<template>
  <div class="container" @click="onClick">
    <div class="top">
      <span class="phase">{{ props.phase || '—' }}</span>
      <div class="distance-group">
        <span class="material-symbols-outlined size-24 location-icon">
          location_on
        </span>
        <!-- distance will likely be its own conical field, ultimately -->
        <span class="distance">{{ Math.trunc(props.location[0].distance) || '—' }} miles</span>
      </div>
    </div>
    <div class="location">{{ props.location[0].city || '—' }}, {{ props.location[0].country || '—' }}</div>
    <div class="txt" :class="{ 'line-clamp': !hovered }">
      {{ props.description || '—' }}
    </div>
    <div class="id">
      <span>{{ props.id || '—' }}</span>
    </div>
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 dātma, inc™
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

import { defineEmits, defineProps, ref } from 'vue'
const hovered = ref(false)

const emit = defineEmits(['openDetailsModal'])

const props = defineProps({
  location: Array,
  description: String,
  phase: String,
  distance: Number,
  id: String,
})

const onClick = () => {
  emit('openDetailsModal', props.id, props.description, 'Trial')
}

</script>

<style lang="scss" scoped>
.container {
  margin-left: -10px;
  transition: all linear 200ms;
  display: flex;
  width: calc(210px - 2vw);
  min-height: calc(130px - 2vh);
  max-height: 130px;
  padding: 12.96px;
  flex-direction: column;
  border-radius: 9.72px;
  background: #F7F9FB;
  justify-content: flex-start;
  align-items: flex-start;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 9px;
  color: rgba(0, 0, 0, 0.40);

  cursor: pointer;

  &:hover {
    background: var(--Grey200);
  }

  &:hover>.txt {
    color: var(--Black);
  }

  &:hover>.location {
    font-weight: 600;
  }
}

.location {
  color: var(--Black);
  margin: 4px 0;
}

.txt {
  flex: 1 0 0;
  height: 4px;
  align-self: stretch;
  overflow: hidden;
  color: var(--label, rgba(0, 0, 0, 0.40));
  text-overflow: ellipsis;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: -0.162px;
  text-align: left;
  margin-bottom: 4px;
}

.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.phase {
  margin-right: 20px;
  color: var(--Grey700);
  background-color: #e9ffaa;
  width: max-content;
  border-radius: 4px;
  margin: 2px;
  padding: 4px;
  text-align: center;
  height: 98%
}

.top {
  display: flex;
}

.distance-group {
  padding: 3px;
  display: flex;
  color: var(--Grey700);
  background-color: var(--Grey300);
  width: max-content;
  border-radius: 4px;
  margin: 2px;
  text-align: center;
  justify-content: flex-start;
  align-items: center;
  height: 90%
}

.location-icon {
  padding-bottom: 3px;
  font-size: 120%;
}

.id {
  color: var(--Grey600);
  margin-top: 5px;
}
</style>
